module.exports = __webpack_public_path__ + "img/gld_gbt70_1_2000.prt.74bcf4e5.jpg";